import React from "react";

export const AssociationPlane = ({ x, y, z = 0, opacity = 0.05 }) => {
  return (
    <mesh position={[x.range()[1] / 2, (y.range()[1] - y.range()[0]) / 2, z]}>
      <planeBufferGeometry
        attach="geometry"
        args={[
          x.range()[1] - x.range()[0],
          y.range()[1] - y.range()[0],
          32,
          32,
        ]}
      />
      <meshStandardMaterial
        depthTest={false}
        opacity={opacity}
        // side={THREE.DoubleSide}
        // blending={THREE.NormalBlending}
        transparent
        attach="material"
        color={`rgba(255, 255, 255)`}
      />
    </mesh>
  );
};
